function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createMemoStyles } from '@wds/utils';
var useStyles = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing,
    palette = _ref.palette;
  return {
    notificationsItem: function notificationsItem(_ref2) {
      var read = _ref2.read;
      return _objectSpread({
        padding: [spacing[4], spacing[4], spacing[4], 40],
        borderBottom: [1, 'solid', palette.border.muted],
        position: 'relative',
        whiteSpace: 'normal',
        '& a': {
          textDecoration: 'underline'
        },
        '& abbr': {
          textDecoration: 'underline',
          textDecorationStyle: 'dotted'
        },
        '&:before': {
          display: 'none'
        },
        '&:after': {
          content: '""',
          position: 'absolute',
          left: 0,
          bottom: -1,
          width: 40,
          height: 1,
          backgroundColor: '#fff'
        }
      }, !read && {
        '&:before': {
          position: 'absolute',
          height: spacing[2],
          width: spacing[2],
          borderRadius: '50%',
          backgroundColor: palette.error.main,
          content: '""',
          top: 57,
          transform: 'translateY(-4px)',
          left: spacing[4]
        },
        '&:hover': {
          backgroundColor: palette.background.accent
        }
      });
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStylesNotificationItem.js.map